import { Injectable, InjectionToken, Type } from '@angular/core';
import { flatten, unionWith } from 'lodash';



export interface ReplaceableComponentConfig {
  // original can be component selector, component class name or component class
  original: string | any, 
  component: any
}

export const APP_REPLACEABLE_CONFIG = new InjectionToken<ReplaceableComponentConfig[]>('APP_REPLACEABLE_CONFIG');

@Injectable({
  providedIn: 'root'
})
export class ReplaceableConfigService {

 componentsConfig: ReplaceableComponentConfig[] = [];


  setComponentsConfig(componentsConfig: ReplaceableComponentConfig[]): void {
    this.componentsConfig = unionWith((flatten(componentsConfig || [])).filter(i => i), this.componentsConfig, (a: ReplaceableComponentConfig, b: ReplaceableComponentConfig) => {
      return a.original === b.original
    });
  }

  getReplaceable(componentDescriptors: any[]) {
    return this.componentsConfig.find(config => componentDescriptors.includes(config.original))?.component; 
  }
}
